// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9f2920be","213":"3149e995","239":"7821a475","313":"529b2e63","349":"34f0d1bc","368":"cb3ccf4d","396":"4358f7dc","455":"7b56d213","705":"83b3484a","722":"182ad610","818":"a966587f","821":"fb4af79b","899":"d0e63a6f","976":"daa399c2","987":"cb3ccf4d"}[chunkId] + ".chunk.js";
};